import { Layout } from "antd";
import React from "react";
import { Route } from "react-router-dom";
const { Content } = Layout;

const AppContent = ({ component: Component, rest }) => (
  <Content>
    <div className="site-layout-background site-content">
      <Route
        {...rest}
        component={(props) => (
          <>
            <Component {...props} />
          </>
        )}
      />
    </div>
  </Content>
);
function areEqual(prevProps, nextProps) {
  const prev = prevProps && prevProps.rest.path;
  const next = nextProps && nextProps.rest.path;
  return prev === next;
}

export default React.memo(AppContent, areEqual);
